export enum NatureVegetationPlacette {
    Aucune = 0,
    Bryophytes,
    Hydrophytes,
    Helophytes = 10,
    Algues = 18
}
